import { forwardRef } from 'react'

import { twMerge } from '~/lib/utils'

import { InputError } from '../input-error'

export type TextareaProps = {
  errorMessages?: React.ReactNode
} & React.TextareaHTMLAttributes<HTMLTextAreaElement>

export const Textarea = forwardRef<HTMLTextAreaElement, TextareaProps>(
  ({ className, errorMessages, ...props }, ref) => {
    return (
      <div className="flex flex-col gap-y-1">
        <textarea
          className={twMerge(
            'flex min-h-[80px] w-full rounded border px-4 py-2 placeholder:text-grayText',
            errorMessages
              ? 'border-2 border-alert'
              : 'border-grayBtn focus:border-2 focus:border-brand',
            className,
          )}
          ref={ref}
          {...props}
        />
        {errorMessages && (
          <InputError data-testid={`${props.name}-error`}>
            {errorMessages}
          </InputError>
        )}
      </div>
    )
  },
)

Textarea.displayName = 'Textarea'
